import { PALETTE } from '../tokens';

/**
 * InsightCard — subtle card showing the current insight string.
 *
 * Props:
 *   insight — string from GET /api/insights/{user_id} → current_insight
 *   loading — show skeleton
 */
export function InsightCard({ insight, loading = false }) {
  if (loading) return <InsightCardSkeleton />;

  // If no insight yet: show gentle empty state
  if (!insight) {
    return (
      <div
        style={{
          background: PALETTE.surfaceAlt,
          borderRadius: 16,
          padding: '16px 20px',
        }}
      >
        <p
          style={{
            fontSize: 13.5,
            color: PALETTE.textFaint,
            lineHeight: 1.72,
            fontWeight: 300,
            fontStyle: 'italic',
            margin: 0,
          }}
        >
          Still watching. Something will surface soon.
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        background: PALETTE.surfaceAlt,
        borderRadius: 16,
        padding: '16px 20px',
      }}
    >
      <p
        style={{
          fontSize: 13.5,
          color: PALETTE.textMid,
          lineHeight: 1.72,
          fontWeight: 300,
          margin: 0,
        }}
      >
        {insight}
      </p>
    </div>
  );
}

function InsightCardSkeleton() {
  return (
    <div
      style={{
        background: PALETTE.surfaceAlt,
        borderRadius: 16,
        padding: '16px 20px',
      }}
    >
      <div
        style={{
          height: 13,
          width: '90%',
          background: PALETTE.border,
          borderRadius: 6,
          marginBottom: 8,
        }}
      />
      <div
        style={{
          height: 13,
          width: '65%',
          background: PALETTE.border,
          borderRadius: 6,
        }}
      />
    </div>
  );
}
